<template>
    <BaseContentfulContentBlock
        :contentRows="contentRows"
        :contentTitle="contentTitle"
        :contentStartTime="contentStartTime"
        :contentEndTime="contentEndTime"
        :applyRowClass="applyRowClass"
        :userIsEligibleToViewRow="userIsEligibleToViewRow"
        :pageGridWidth="pageGridWidth"
    >
        <template #default="{ module, numberOfModules, paddingBottom, hasEnteredViewport }">
            <ContentfulModule
                :module="module"
                :numberOfModules="numberOfModules"
                :paddingBottom="paddingBottom"
                :contentTitle="contentTitle"
                :hasEnteredViewport="hasEnteredViewport"
            />
        </template>
    </BaseContentfulContentBlock>
</template>

<script setup>
import { useGetters, useState } from '~coreModules/core/js/composables/vuexHelpers';

import { userIsEligibleToViewContent } from '~modules/contentful/js/contentful-utils';

import { BOX_MODULE_NAME } from '~modules/box/js/box-store';
import { PROFILE_MODULE_NAME } from '~modules/profile/js/profile-store';

import BaseContentfulContentBlock from '~coreModules/contentful/components/BaseContentfulContentBlock.vue';
import ContentfulModule from '~modules/contentful/components/ContentfulModule.vue';

defineProps({
    contentRows: {
        type: Array,
        default: () => [],
        required: true,
    },
    contentTitle: {
        type: String,
        default: null,
    },
    contentStartTime: {
        type: String,
        default: null,
    },
    contentEndTime: {
        type: String,
        default: null,
    },
    applyRowClass: {
        type: Boolean,
        default: true,
    },
    pageGridWidth: {
        type: String,
        default: '',
    },
});

const { loggedIn } = useGetters(['loggedIn']);
const { effectiveSubscriptionStatus } = useGetters(PROFILE_MODULE_NAME, ['effectiveSubscriptionStatus']);
const { hasRecentOrder } = useGetters(BOX_MODULE_NAME, ['hasRecentOrder']);

const { boxOrderStatus } = useState(BOX_MODULE_NAME, {
    boxOrderStatus: state => state.boxOrderStatus,
});

function userIsEligibleToViewRow(row) {
    return userIsEligibleToViewContent({
        eligibilityRules: row.eligibility,
        isLoggedIn: loggedIn.value,
        boxOrderStatus: boxOrderStatus.value,
        subscriptionStatus: effectiveSubscriptionStatus.value,
        hasRecentOrder: hasRecentOrder.value,
    });
}
</script>
